import React from "react";
import axios from "axios";
import { notifications } from '@mantine/notifications';
import { Text } from '@mantine/core';

import { useLoginContext } from "../../context/loginContext";
import { BE_API_THREE, utils } from "../../utils/globalVariables";
// import { safeValue, CustomerCategoryIcon, sqlDateToIsoDate, safetyDecodeJWT } from "../../utils/globalFunctions";

// import ModalResponse from "../../components/general/ModalResponse";
// import ModalTakeAction from "../../components/general/ModalTakeAction";
import PaperWrapper from "../../components/utilities/PaperWrapper";

import HistoryProjectCustomerData from "./HistoryProjectCustomerData";

const HistoryProjectCustomer = ({
    stateURI1,
    stateUtilsRef,
    fnCounter,
    stateData,
}) => {

    const mountedRef = React.useRef(true);

    // const theme = useMantineTheme();
    const { loginContext, handleSetLoginContext } = useLoginContext();

    const notificationId = React.useRef({
        errorGetData: 'historyProjectCustomer-1',
    })

    const [data, setData] = React.useState({
        data: [],
        dataLoadingInit: false,
        dataFlag: 'idle',
        projectId: '',
        refresh: new Date()
    });

    React.useEffect(() => {
        return () => {
            mountedRef.current = false;
        }
    }, [])

    React.useEffect(() => {
        fnCounter(Array.isArray(data.data) ? data.data.length : 0)
    }, [fnCounter, data.data])

    React.useEffect(() => {
        if (stateURI1) {

            setData(d => ({
                ...d,
                dataLoadingInit: true,
            }))

            const formDT = new FormData();
            const formDTHeader = { 'Content-Type': 'application/json' }

            formDT.append('json_token', loginContext.syswebapp);
            formDT.append('flag_all', utils.flagAll);
            formDT.append('project_id', stateURI1);
            formDT.append('project_process', stateUtilsRef.projectProcess);
            formDT.append('project_is_cancel', stateUtilsRef.projectIsCancel);
            formDT.append('project_process_sudah_diambil', utils.projectProcess.sudah_diambil.value);

            axios({
                method: 'post',
                url: BE_API_THREE + '/history_project_customer_by_barang',
                data: formDT,
                headers: formDTHeader,
            }).then((response) => {
                if (!mountedRef.current) return null;

                setData(d => ({ ...d, dataLoadingInit: false }));

                if (response.data.flag_status === 'isset') {
                    setData(d => ({
                        ...d,
                        data: response.data.data,
                        dataFlag: Array.isArray(response.data.data) && (response.data.data.length > 0) ? true : false,
                        projectId: response.data.project_id
                    }));
                }

                if (response.data.flag_status === 'error') {
                    notifications.show({
                        id: notificationId.current.errorGetData,
                        title: utils.notification.warning.caption,
                        message: response.data.pesan,
                        color: utils.notification.warning.color,
                        icon: utils.notification.warning.icon,
                        withBorder: true,
                        autoClose: true,
                    })
                }

                if (response.data.flag_status === 'no-data') {
                    setData(d => ({
                        ...d,
                        dataFlag: false
                    }));
                }

                if (response.data.flag_status === 'invalid-json-token') {
                    handleSetLoginContext(null);
                }

                if (response.data.flag_status === 'user-inactive') {
                    handleSetLoginContext(null);
                }
            }).catch(error => {
                if (!mountedRef.current) return null;

                setData(d => ({
                    ...d,
                    dataLoadingInit: false
                }))

                notifications.show({
                    id: notificationId.current.errorGetData,
                    title: utils.notification.warning.caption,
                    message: error.message,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            })
        }
    }, [handleSetLoginContext, loginContext, loginContext.syswebapp, stateURI1, stateUtilsRef.projectProcess, stateUtilsRef.projectIsCancel, stateData.refresh, data.refresh])

    return (
        <React.Fragment>
            {data.dataLoadingInit &&
                <PaperWrapper>
                    <Text size='sm' color="dimmed">Loading Data History..</Text>
                </PaperWrapper>
            }

            {!data.dataLoadingInit && (data.dataFlag === false) &&
                <Text color="dimmed" align="center" py='2rem'>Tidak ada history project.</Text>
            }

            {!data.dataLoadingInit && (data.dataFlag === true) &&
                <HistoryProjectCustomerData
                    stateData={{
                        data: data.data,
                        projectId: data.projectId
                    }}

                    fnSuccessKlaimFromPengerjaanHistory={() => {
                        setData(d => ({ ...d, refresh: new Date() }))
                    }}
                />
            }
        </React.Fragment>
    )
}

export default React.memo(HistoryProjectCustomer);